export function SearchIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 23 25">
      <path
        fill="currentColor"
        d="m22.16 20.679-5.023-5.024a9.77 9.77 0 0 0 1.786-5.581c.112-5.135-4.13-9.377-9.376-9.377a9.48 9.48 0 0 0-9.489 9.489 9.48 9.48 0 0 0 9.489 9.488c1.34 0 2.79-.335 4.018-.893l5.247 5.247c.446.446 1.004.67 1.674.67.558 0 1.228-.224 1.674-.67l.112-.112c.447-.447.67-1.005.67-1.563-.112-.67-.335-1.228-.782-1.674Zm-5.916-10.493c0 3.683-3.014 6.697-6.697 6.697-3.684 0-6.698-3.014-6.698-6.697 0-3.684 3.014-6.698 6.698-6.698 3.683 0 6.697 3.014 6.697 6.698Z"
      />
    </svg>
  );
}
